import { render, staticRenderFns } from "./IndexAdmin.vue?vue&type=template&id=44998f34&scoped=true"
import script from "./IndexAdmin.vue?vue&type=script&lang=js"
export * from "./IndexAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44998f34",
  null
  
)

export default component.exports